import { NgModule } from 'ng-metadata/core';
import { WafersComponent } from './wafers.component';
import { WaferComponent } from './wafer.component';
import './wafers.scss';

/**
 * @ngdoc module
 * @name mw.components.wafers
 * @description
 *
 * Wafer
 */
@NgModule({
    imports: ['ngMaterial'],
    declarations: [ WafersComponent, WaferComponent ]
})
export class WafersModule {}



// WEBPACK FOOTER //
// ./src/lib/components/wafers/wafers.module.ts